<mat-card>
    <mat-card-header>
      <mat-card-title *ngIf="!isSignedIn">Restricted Area</mat-card-title>
      <mat-card-title *ngIf="isSignedIn && !isAuthorized">Missing Permission</mat-card-title>
      <mat-card-title *ngIf="isSignedIn && isAuthorized">Dashboard</mat-card-title>
    </mat-card-header>
    <mat-card-content>
            <mat-icon *ngIf="!isAuthorized">lock</mat-icon>
    </mat-card-content>
</mat-card>